import { FETCH_STATES } from "src/redux/Tx/constants";
import { Recall } from "./types";

const defaultState = {
    requestRows: [],
    requestComment: "",
    hasUpdate: false,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case Recall.SET_RECALLS_LIST_HAS_UPDATE:
            return {
                ...state,
                hasUpdate: action.hasUpdate,
            };

        case Recall.SET_RECALL_REQUEST_ENTRIES:
            return {
                ...state,
                requestRows: action.entries.map((entry, index) => ({
                    ...entry,
                    id: index + 1,
                })),
            };

        case Recall.SET_RECALL_REQUEST_COMMENT:
            return {
                ...state,
                requestComment: action.comment,
            };

        case Recall.DELETE_RECALL_REQUEST_ENTRY:
            let newRequestRows = [...state.requestRows];
            newRequestRows.splice(action.rowId - 1, 1);

            return {
                ...state,
                requestRows: newRequestRows.map((row, index) => ({
                    ...row,
                    id: index + 1,
                })),
            };

        case Recall.UPDATE_RECALL_REQUEST_ENTRY:
            return {
                ...state,
                requestRows: state.requestRows.map((row) =>
                    row.id === action.rowData.id ? { ...action.rowData } : row
                ),
            };

        case Recall.ATTACH_MARKET_DATA:
            const marketData = { ...action.marketData };
            const mdIndex = action.listTicker;

            return {
                ...state,
                requestRows: state.requestRows.map((row) => {
                    const stockId = row.ticker;

                    if (!mdIndex.includes(stockId)) return row;

                    const stockData = marketData[stockId]?.data;
                    if (stockData) {
                        return {
                            ...row,
                            marketData: {
                                status: FETCH_STATES.FETCHED,
                                data: stockData,
                                error: null,
                            },
                            securityName: stockData.name,
                            securityLocalName: stockData.localName,
                            country: stockData.countryCode,
                            TradeableDates: stockData.tradableDates.map((s) =>
                                s.replace(/-/g, "")
                            ),
                        };
                    }

                    return {
                        ...row,
                        marketData: {
                            status: FETCH_STATES.ERROR,
                            error: "Not Found",
                        },
                        ticker: row.ticker + " ",
                        securityName: "ERROR",
                        securityLocalName: "ERROR",
                        country: "ERROR",
                    };
                }),
            };
        default:
            return state;
    }
};
